(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PhotoIbqDialogController', PhotoIbqDialogController);

    PhotoIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Photo', 'MusicalPiece', 'Person'];

    function PhotoIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Photo, MusicalPiece, Person) {
        var vm = this;

        vm.photo = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.musicalpieces = MusicalPiece.query();
        vm.people = Person.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.photo.id !== null) {
                Photo.update(vm.photo, onSaveSuccess, onSaveError);
            } else {
                Photo.save(vm.photo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:photoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setPhotoFile = function ($file, photo) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        photo.photoFile = base64Data;
                        photo.photoFileContentType = $file.type;
                        photo.photoPath=$file.name;

                    });
                });
            }
        };

    }
})();
